function isEmail(text) {
    return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(text);
  }
  
  function errorMessage(error) {
    const { responseText } = error.response.request;
    if (responseText) {
      try {
        return (JSON.parse(responseText).error.message);
      } catch { /* empty */ }
    }
  }
  
  export { isEmail, errorMessage };
  
  export function isValidPrice(string) {
    // const regex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
    // eslint-disable-next-line no-useless-escape
    const regex = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;
    return new RegExp(regex).test(string.toString().split(' ').join(''));
  }
  
  export function isDecimal(string) {
    if (string === null) {
      return false;
    }
    return string.toString().includes('.');
  }
  
  export function isValidUrl(string) {
    try {
      // eslint-disable-next-line no-new
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  }
  